import React, { Component } from 'react'
import { View, StyleSheet } from 'react-native'
import ObjectRenderer from './ObjectRenderer'
import AppContext from '../contexts/AppContext'

export default class ComponentInstance extends Component {
  static contextType = AppContext

  getComponent = () => {
    const { object } = this.props
    const { getApp } = this.context
    const { componentId } = object.attributes

    const app = getApp()
    const component = app.components[componentId]

    return component
  }

  render() {
    const {
      object,
      active,
      topScreen,
      isResponsiveComponent,
      getBinding,
      getBindings,
      getBindingsList,
    } = this.props
    const { layout } = object

    const component = this.getComponent()

    if (!component) {
      return null
    }

    const children = component.layout.body

    return (
      <View style={[styles.wrapper, layout]}>
        {children.map(obj => (
          <ObjectRenderer
            isReusableComponent
            key={obj.id}
            object={obj}
            component={component}
            active={active}
            topScreen={topScreen}
            isResponsiveComponent={isResponsiveComponent}
            getBinding={getBinding}
            getBindings={getBindings}
            getBindingsList={getBindingsList}
          />
        ))}
      </View>
    )
  }
}

const styles = StyleSheet.create({
  wrapper: {},
})
